"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscapeTask = exports.ESCAPE = void 0;
var interface_1 = require("../../interface");
exports.ESCAPE = 'ESCAPE';
var EscapeTask = /** @class */ (function () {
    function EscapeTask() {
        var _this = this;
        this.key = 'ESCAPE';
        this.version = 0;
        this.handleKeyUp = function (e) {
            if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
                var subscribers = _this.getSubscribers();
                var subscriber = subscribers[subscribers.length - 1];
                /* istanbul ignore else */
                if (subscriber) {
                    subscriber.notify();
                }
            }
        };
    }
    EscapeTask.prototype.onRegister = function () {
        window.addEventListener('keyup', this.handleKeyUp);
    };
    EscapeTask.prototype.onDestroy = function () {
        window.removeEventListener('keyup', this.handleKeyUp);
    };
    EscapeTask.prototype.getSubscribers = function () {
        return (0, interface_1.getGlobalBehaviors)().getSubscribers(this.key);
    };
    return EscapeTask;
}());
exports.EscapeTask = EscapeTask;
//# sourceMappingURL=EscapeTask.js.map